import Input from './input'

type InputCheckboxProps = {
    label: string
    error?: { key: string; values: object }
    value: boolean
    onChange: (value: boolean) => void
    required?: boolean
    translationLabel?: any
    dataCy?: string
}

const InputCheckbox = ({ label, value, error, required = false, onChange, translationLabel, dataCy }: InputCheckboxProps) => {
    return (
        <Input label={''} hideLabel={true} error={error} required={required}>
            <input
                type="checkbox"
                id={label}
                checked={value}
                required={required}
                data-cy={dataCy}
                onChange={(event) => {
                    onChange(event.target.checked)
                }}
                className="align-bottom mb-[6px] w-4 h-4 border border-[#d4d4d4] checked:bg-blue-500 checked:border-blue-500 checked:ring-blue-600 max-tablet:w-3 max-tablet:h-3"
            />
            <label htmlFor={label} className="pl-3 text-base text-left max-tablet:text-sm max-tablet:pl-2 cursor-pointer">
                {translationLabel || label}
            </label>
        </Input>
    )
}

export default InputCheckbox
